import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  default as CustomSelect,
  default as Select,
} from "../../../components/Select/Select";
import {
  getAppointmentHistoriesByPetId,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getClinicFacilities,
  getClinicHolidays,
  getClinicStocksWoLoader,
  getServices,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import {
  createDiagnosticsWoLoader,
  createProcedureWoLoader,
  petAppointment,
} from "../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  appointmentLaterList,
  appointmentList,
  doneAtList,
  oldIssueList,
  serviceTypes,
  serviceTypeWOSurgery,
  typeAppointemnt,
  typeList,
  typeListNew,
} from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getAllSelectedSlots,
  getAvailableBayAtTime,
  getOnlyAvailableSlots,
  getProcedureDetails,
  getRequiredSlotList,
  getSlotsForGroomer,
  getUnAvailableGroomList,
  getUpcoming60Dates,
} from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const initValues = {
  bookingType: "Walk-in",
  consultationMode: "Physical",
  serviceType: { name: "Consultation", value: "Consultation" },
  reason: [],
  vetName: null,
  appointmentOption: "Immediate",
  date: new Date(),
  referenceCase: null,
  serviceName: [],
  remarks: "",
  facility: null,
};
const initErrors = {};
const initTimeObj = { times: [], ids: [] };

const BookAnAppointment = ({
  modalVisible,
  setBookModVisible,
  selectedPet,
  prevAppointmentId = null,
}) => {
  const dispatch = useDispatch();
  const [modOpen, setModOpen] = useState(false);
  const [petValues, setPetValues] = useState(initValues);
  const [petErrors, setPetErrors] = useState(initErrors);
  const [selectTime, setSelectTime] = useState(null);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const {
    userDetails,
    vetAvailability,
    vetBookedApnts,
    petApntHistories,
    services,
    facilities,
    clinicStocks,
  } = useSelector((state) => state?.clinic);
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);

  useEffect(() => {
    dispatch(getClinicHolidays());
    dispatch(getAppointmentHistoriesByPetId(selectedPet?.petId));
    dispatch(getServices());
    dispatch(getClinicStocksWoLoader());
    dispatch(getClinicVets("?type=all"));
  }, []);

  useEffect(() => {
    setModOpen(modalVisible);
  }, [modalVisible]);

  useEffect(() => {
    if (prevAppointmentId && petApntHistories?.length > 0) {
      const reqObj = { ...petValues };
      const reqHistory = petApntHistories?.find(
        (hist) => hist?.appointmentId === prevAppointmentId
      );
      if (reqHistory) {
        reqObj.reason = ["FollowUp"];
        reqObj.referenceCase = {
          name: `Case Id: ${reqHistory?.caseId ?? ""} ${
            reqHistory?.serviceType
          }${
            reqHistory?.serviceType === "Consultation"
              ? ` | ${
                  Array.isArray(reqHistory?.reason)
                    ? reqHistory?.reason?.join(", ")
                    : reqHistory?.reason
                }`
              : ""
          }`,
          value: reqHistory?.appointmentId ?? prevAppointmentId,
        };
      }
      setPetValues(reqObj);
    }
  }, [prevAppointmentId, petApntHistories]);

  useEffect(() => {
    if (
      !petValues?.vetName?.value ||
      !petValues?.date ||
      !petValues?.appointmentOption ||
      !petValues?.consultationMode
    ) {
      return;
    }
    if (petValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(petValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: petValues?.vetName?.value,
          type:
            (role === "ROLE_CLINIC" ? profile?.id : userDetails?.id) ===
            petValues?.vetName?.value
              ? "Physical"
              : petValues?.consultationMode,
        })
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: petValues?.vetName?.value,
          date: moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        })
      );
    }
  }, [
    petValues?.vetName?.value,
    petValues?.date,
    petValues?.appointmentOption,
    petValues?.consultationMode,
  ]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const handleReset = () => {
    setPetValues(initValues);
    setPetErrors(initErrors);
    setSelectTime(null);
    setSelectTimeIdError(false);
  };

  const onCloseMod = () => {
    handleReset();
    setModOpen(false);
    setBookModVisible(false);
    setSelectTime(null);
  };

  const onChange = (value, name) => {
    const reqObj = { ...petValues, [name]: value };
    const errObj = { ...petErrors };
    if (name === "serviceType") {
      reqObj.serviceName = [];
      if (value?.value === "Surgery" || value?.value === "Grooming") {
        dispatch(getClinicFacilities());
      }
    }
    if (name === "serviceName") {
      errObj.serviceName = value?.length === 0 ? "This field is required" : "";
    }
    setPetErrors(errObj);
    setPetValues(reqObj);
  };

  const handleSelectectedTimeIds = (time) => {
    const reqTimeIds = [...timeObject?.times, time];
    let ids = [];
    const reqList = {
      times: reqTimeIds?.length > 2 ? [time] : reqTimeIds,
    };
    if (reqList?.times?.length === 2) {
      ids = getAllSelectedSlots(
        getRequiredSlotList({
          availability: vetAvailability,
          date: petValues?.date,
          bookedApnts: vetBookedApnts,
        }),
        reqTimeIds
      );
      reqList.ids = ids;
    } else {
      ids.push(time);
      reqList.ids = ids;
    }
    setTimeObject(reqList);
    setSelectTimeIdError(reqTimeIds?.length === 2 ? false : true);
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const getHistoryList = () => {
    if (!petApntHistories || petApntHistories?.length === 0) return [];
    return petApntHistories?.map((hl) => ({
      name: `Case Id: ${hl?.caseId ?? ""} ${hl?.serviceType}${
        hl?.serviceType === "Consultation"
          ? ` | ${
              Array.isArray(hl?.reason) ? hl?.reason?.join(", ") : hl?.reason
            }`
          : ""
      }`,
      value: hl?.appointmentId,
    }));
  };

  const getServiceList = (itm) => {
    const reqCat =
      itm === "Grooming"
        ? "Hygiene & Grooming"
        : itm === "Lab Tests"
        ? "Lab"
        : "Radiology";
    const reqList = [];
    let filList = services?.data?.filter((sl) => sl?.category === reqCat);
    if (itm === "Grooming") {
      if (facilities?.filter((fl) => fl?.type === "BathBays").length === 0) {
        filList = filList?.filter(
          (sl) =>
            sl?.subCategory !== "Bathing" &&
            sl?.subCategory !== "Spa/Pampering Services"
        );
      }
    }

    filList?.forEach((li) => {
      if (li?.serviceVariants?.length > 0) {
        li?.serviceVariants?.forEach((vrnt) => {
          const reqObj = {
            serviceId: li?.serviceId,
            serviceName: li?.serviceName,
            variantName: vrnt?.variantName ?? "",
            estimatedDuration: vrnt?.estimatedDuration ?? "",
            servicePrice: vrnt?.servicePrice ?? 0,
            variantId: vrnt?.variantId ?? null,
            value: vrnt?.variantName ?? "",
            name: vrnt?.variantName ?? "",
            category: li?.category,
            subCategory: li?.subCategory,
          };
          reqList.push(reqObj);
        });
      } else {
        const reqObj = {
          serviceId: li?.serviceId,
          serviceName: li?.serviceName,
          servicePrice: li?.servicePrice ?? 0,
          estimatedDuration: li?.estimatedDuration ?? "",
          name: li?.serviceName,
          value: li?.serviceName,
        };
        reqList.push(reqObj);
      }
    });
    return reqList ?? [];
  };

  const getVetList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => {
          if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
            return vl;
          }
        })
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
    });
    return reqVetList;
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
    });
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType =
      type === "Grooming"
        ? "ROLE_GROOMER"
        : // "Groomer"
          "ROLE_RADIOLOGY";
    //  type === "Lab Tests"
    // ? "Laboratory Technician"
    // : "Radiology Technician";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        // ?.filter((vl) => vl?.accessRole === reqType || vl?.role === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : userDetails?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : userDetails?.id,
    });
    return reqVetList;
  };

  const getFacilitiesByType = (type) => {
    const reqType = type === "Surgery" ? "OperationTheatre" : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const getFacilityUnAvailListById = (id) => {
    const reqFacility = facilities?.find((fl) => fl?.facilityId === id) ?? {};
    if (!reqFacility) return [];
    return (
      reqFacility?.clinicFacilitiesUnavaility
        ?.filter(
          (ua) =>
            ua?.appointmentDate === moment(petValues?.date).format("YYYY-MM-DD")
        )
        ?.map((li) => ({
          ...li,
          startTime: li?.appointmentStartTime,
          endTime: li?.appointmentEndTime,
        })) ?? []
    );
  };

  const handleAddDiag = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const form = new FormData();
      form.append("appId", apntId);
      form.append("type", li?.category);
      form.append("testName", li?.serviceName);
      form.append("doneAt", doneAtList?.[0]?.value);
      form.append("sampleCollected", false);
      form.append("priority", "Routine");
      form.append("price", li?.servicePrice);
      form.append("tax", 0);
      form.append(
        "dueDate",
        moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date)
        ).format("YYYY-MM-DD")
      );
      form.append("remark", "");
      form.append("serviceId", li?.serviceId);
      form.append("variantId", li?.variantId);
      form.append("variantName", li?.variantName);
      form.append("status", "In Progress");
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId: apntId,
          form,
          formData: true,
        })
      );
    });
  };

  const handleAddProcedure = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const procedureDetails = getProcedureDetails(
        li?.serviceId,
        li?.variantId,
        li?.serviceName,
        services?.data ?? [],
        clinicStocks?.data ?? [],
        clinicDet?.pharmacyTaxId
      )?.procedureDetails;
      const data = {
        procedureName: li?.serviceName,
        serviceId: li?.serviceId,
        category: li?.category,
        subCategory: li?.subCategory,
        remarks: li?.remarks ?? "",
        doneAt: moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date)
        ).format("YYYY-MM-DD"),
        status: "Pending",
        petId: selectedPet?.petId,
        appointmentId: apntId,
        serviceCharge: li?.servicePrice,
        serviceType: li?.variantName,
        procedureDetails,
      };
      dispatch(createProcedureWoLoader(data));
    });
  };

  const handleSubmit = () => {
    if (
      petValues?.serviceType?.value === "Grooming" ||
      petValues?.serviceType?.value === "Lab Tests" ||
      petValues?.serviceType?.value === "Radiology Tests" ||
      petValues?.serviceType?.value === "Others"
    ) {
      if (petValues?.serviceName?.length === 0) {
        setPetErrors({
          ...petErrors,
          serviceName: "This field is required",
        });
        return;
      }
    }
    dispatch(showLoader());
    const data = {
      bookingType: petValues?.bookingType,
      consultationMode: petValues?.consultationMode,
      serviceType: petValues?.serviceType?.value,
      remarks: petValues?.remarks,
      immediate: petValues?.appointmentOption === "Immediate",
      appointmentDate:
        petValues?.appointmentOption === "Immediate"
          ? moment(new Date()).format("YYYY-MM-DD")
          : moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
      doctorId: petValues?.vetName?.value,
    };
    if (petValues?.appointmentOption !== "Immediate") {
      if (petValues?.serviceType?.value === "Surgery") {
        data.appointmentStartTime = timeObject?.ids?.[0]?.startTime;
        data.appointmentEndTime =
          timeObject?.ids?.[timeObject?.ids?.length - 1]?.endTime;
        data.facility = petValues?.facility?.name;
        data.facilityId = petValues?.facility?.value;
      } else {
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(
          selectTime,
          getRequiredSlotList({
            availability: vetAvailability,
            date: petValues?.date,
            isDuration: true,
          })
        );
      }
    }
    if (
      petValues?.serviceType?.value !== "Consultation" &&
      petValues?.serviceType?.value !== "Surgery"
    ) {
      data.serviceNames = petValues?.serviceName?.map((li) => ({
        serviceName: li?.serviceName,
        serviceId: li?.serviceId,
        variantId: li?.variantId,
      }));
    }
    if (
      petValues?.serviceType?.value === "Grooming" &&
      petValues?.appointmentOption !== "Immediate"
    ) {
      if (petValues?.serviceName?.length === 0) return;
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Bathing") ||
            item?.subCategory?.includes("Spa/Pampering Services")
        )
      ) {
        const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
          return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
        }, 0);
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
        if (facilities?.filter((fl) => fl?.type === "BathBays")?.length === 1) {
          data.facility = getFacilitiesByType("Grooming")?.[0]?.name;
          data.facilityId = getFacilitiesByType("Grooming")?.[0]?.value;
        } else {
          const reqFacility = getAvailableBayAtTime(
            facilities?.filter((fl) => fl?.type === "BathBays"),
            selectTime
          );
          if (reqFacility) {
            data.facility = reqFacility?.name;
            data.facilityId = reqFacility?.facilityId;
          }
        }
      }
    }
    if (
      petValues?.serviceType?.value === "Radiology Tests" &&
      petValues?.appointmentOption !== "Immediate"
    ) {
      if (petValues?.serviceName?.length === 0) return;
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Imaging") ||
            item?.subCategory?.includes("Endoscopy")
        )
      ) {
        const reqTimeInMins = petValues?.serviceName?.reduce((acc, obj) => {
          return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
        }, 0);
        data.appointmentStartTime = selectTime;
        data.appointmentEndTime = adjustTime(selectTime, reqTimeInMins);
      }
    }
    if (petValues?.serviceType?.value === "Consultation") {
      data.reason = petValues?.reason;
    }
    if (petValues?.referenceCase?.value) {
      data.prevAppointmentId = petValues?.referenceCase?.value;
    }
    dispatch(petAppointment({ data, petId: selectedPet?.petId })).then(
      (res) => {
        if (res?.payload) {
          if (
            (petValues?.serviceType?.value === "Radiology Tests" ||
              petValues?.serviceType?.value === "Lab Tests" ||
              petValues?.serviceType?.value === "Grooming") &&
            res?.payload?.data?.appointmentId
          ) {
            if (
              petValues?.serviceType?.value === "Radiology Tests" ||
              petValues?.serviceType?.value === "Lab Tests"
            ) {
              handleAddDiag(petValues, res?.payload?.data?.appointmentId);
            }
            if (petValues?.serviceType?.value === "Grooming") {
              handleAddProcedure(petValues, res?.payload?.data?.appointmentId);
            }
          }
          setBookModVisible(false);
          onCloseMod();
          dispatch(hideLoader());
        }
      }
    );
    dispatch(hideLoader());
  };

  return (
    <CustomModal
      open={modOpen}
      onClose={onCloseMod}
      header="Book an Appointment"
      modalWidth={80}
      modal
    >
      <Grid container spacing={2} className="ph20 scroll-80vh">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container className="flex-center">
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Card sx={cardSty} className="CustomCard-back-appointment">
                <div className="maint">
                  <div className="flex-row">
                    <Grid item xs={3}>
                      <div className="flex-center">
                        {selectedPet?.petImage ? (
                          <CardMedia
                            image={selectedPet?.petImage}
                            className="CustomCard-img3-bill"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {selectedPet?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <div className="flex-row">
                        <div className="flex-start">
                          <div className="flex-column">
                            <div className="flex-row">
                              <Typography
                                variant="body1"
                                className="mb10 font-bold fs14 capitalize"
                              >
                                {selectedPet?.petName}
                              </Typography>
                              <Typography
                                variant="body1"
                                className={`ml5 font-medium capitalize fs14 ${
                                  selectedPet?.gender === "male"
                                    ? "card-blue-color"
                                    : "card-rose-color"
                                }`}
                              >
                                {`(${selectedPet?.gender})`}
                              </Typography>
                            </div>
                            <Typography
                              variant="body2"
                              className="mb10 txt-regular card-gray-color fs12"
                            >
                              {selectedPet?.breed}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </div>
                  <div className="flex-row iconcontainer flex-space-btwn">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <Typography className="font-bold fs14 capitalize flex-center h35">
                        {selectedPet?.userName}
                      </Typography>
                    </div>

                    <div className="meeting-doctor">
                      {moment(new Date(selectedPet?.dob)).fromNow()} (
                      {selectedPet?.dob})
                    </div>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
          <CustomSelect
            list={typeAppointemnt}
            value={petValues?.bookingType}
            handleChange={(e) => onChange(e?.target?.value, "bookingType")}
            name="bookingType"
            label="Booking Type * "
            select
            helperText={petErrors?.bookingType}
            error={!!petErrors?.bookingType}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
          <CustomSelect
            list={petValues.bookingType === "Walk-in" ? typeListNew : typeList}
            value={
              petValues?.bookingType === "Walk-in"
                ? "Physical"
                : petValues?.consultationMode
            }
            handleChange={(e) => onChange(e?.target?.value, "consultationMode")}
            name="consultationMode"
            label="Consultation Mode * "
            select
            helperText={petErrors?.consultationMode}
            error={!!petErrors?.consultationMode}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <CustomSelect
            list={
              petValues?.consultationMode === "Physical"
                ? serviceTypes
                : serviceTypeWOSurgery
            }
            value={petValues?.serviceType}
            handleChange={(e, value) => onChange(value, "serviceType")}
            search
            helperText={petErrors?.serviceType}
            error={!!petErrors?.serviceType}
            label="Service Type *"
            name="serviceType"
          />
        </Grid>
        {petValues?.serviceType?.value === "Consultation" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={oldIssueList}
              value={petValues?.reason}
              handleChange={(e) => {
                onChange(e, "reason");
              }}
              reason
              label="Reason"
              name="reason"
              helperText={petErrors?.reason}
              error={!!petErrors?.reason}
            />
          </Grid>
        ) : null}
        {petValues?.serviceType?.value === "Grooming" ||
        petValues?.serviceType?.value === "Lab Tests" ||
        petValues?.serviceType?.value === "Radiology Tests" ||
        petValues?.serviceType?.value === "Others" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={getServiceList(petValues?.serviceType?.value)}
              value={petValues?.serviceName}
              handleChange={(e) => onChange(e, "serviceName")}
              service
              label="Service Name *"
              name="serviceName"
              helperText={petErrors?.serviceName}
              error={!!petErrors?.serviceName}
            />
          </Grid>
        ) : null}
        {petValues?.reason?.includes("FollowUp") &&
        petValues?.serviceType?.value === "Consultation" ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomSelect
              list={getHistoryList()}
              value={petValues?.referenceCase}
              handleChange={(e, value) => onChange(value, "referenceCase")}
              search
              label="Reference Case"
              name="referenceCase"
              helperText={petErrors?.referenceCase}
              error={!!petErrors?.referenceCase}
            />
          </Grid>
        ) : null}
        <Grid
          item
          xs={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
          sm={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
          md={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
          lg={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
          xl={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
        >
          <Select
            list={
              petValues?.serviceType?.value === "Grooming" ||
              petValues?.serviceType?.value === "Lab Tests" ||
              petValues?.serviceType?.value === "Radiology Tests"
                ? getOthersByType(petValues?.serviceType?.value)
                : petValues?.serviceType?.value === "Others"
                ? getAllClinicUserList()
                : getVetList()
            }
            value={petValues?.vetName}
            handleChange={(e, value) => onChange(value, "vetName")}
            name="vetName"
            search
            helperText={petErrors?.vetName}
            error={!!petErrors?.vetName}
            label={`${
              petValues?.serviceType?.value === "Grooming"
                ? "Groomer"
                : petValues?.serviceType?.value === "Lab Tests" ||
                  petValues?.serviceType?.value === "Radiology Tests"
                ? "Technician"
                : petValues?.serviceType?.value === "Others"
                ? "Others"
                : "Vet"
            } Name *`}
            labelTop
          />
        </Grid>
        {petValues?.serviceType?.value === "Surgery" ? (
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Select
              list={getFacilitiesByType(petValues?.serviceType?.value)}
              value={petValues?.facility}
              handleChange={(e, value) => onChange(value, "facility")}
              name="facility"
              search
              helperText={petErrors?.facility}
              error={!!petErrors?.facility}
              label="Facility"
              labelTop
            />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <div className="flex-row-ali-cen mtMin5">
            <div className="txt-mont fs14 mtMin5">
              Appointment <span className="red-color">*</span> :
            </div>
            <div className="ml5">
              <CustomCheckbox
                radio
                value={petValues?.appointmentOption}
                onChange={(e) =>
                  onChange(e?.target?.value, "appointmentOption")
                }
                radios={
                  petValues.typeOfAppointment === "Phone"
                    ? appointmentLaterList
                    : appointmentList
                }
                defaultValue={petValues?.appointmentOption}
              />
            </div>
          </div>
          {petErrors?.appointmentOption && (
            <Typography color="error" className="ml5 mt5 fs14">
              Appointment is Required
            </Typography>
          )}
        </Grid>
        {/* {petValues?.serviceType?.value === "Surgery" &&
        petValues?.appointmentOption === "Immediate" ? (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <CustomTextField
              name="kennelNumber"
              fullWidth
              handleChange={(e) => onChange(e?.target?.value, "kennelNumber")}
              value={petValues?.kennelNumber}
              helperText={petErrors?.kennelNumber}
              error={!!petErrors?.kennelNumber}
              label="Kennel Number "
            />
          </Grid>
        ) : null} */}
        {petValues?.appointmentOption === "Later" && (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <div className="mb20">
              <CustomTextField
                name="date"
                value={petValues?.date}
                labelTop
                fullWidth
                handleChange={(e) => onChange(e?.target?.value, "date")}
                mobileDateWithBatch
                markDateList={holidayDates ?? []}
                minDate={new Date()}
              />
            </div>
          </Grid>
        )}
        {petValues?.appointmentOption === "Later" &&
          petValues?.date &&
          petValues?.vetName?.value && (
            <div className="w100Per">
              <div className="flex-row-wrap1 mh10">
                {(petValues?.serviceType?.value === "Surgery" &&
                petValues?.facility?.value
                  ? getOnlyAvailableSlots(
                      getFacilityUnAvailListById(petValues?.facility?.value),
                      getRequiredSlotList({
                        availability: vetAvailability,
                        date: petValues?.date,
                        bookedApnts: vetBookedApnts,
                        holidays,
                      })
                    )
                  : petValues?.serviceType?.value === "Grooming"
                  ? facilities?.filter((fl) => fl?.type === "BathBays")
                      ?.length === 1
                    ? getUnAvailableGroomList(
                        facilities?.filter((fl) => fl?.type === "BathBays"),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                    : getSlotsForGroomer(
                        facilities?.filter((fl) => fl?.type === "BathBays"),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                  : getRequiredSlotList({
                      availability: vetAvailability,
                      date: petValues?.date,
                      bookedApnts: vetBookedApnts,
                      holidays,
                    })
                )?.length > 0 &&
                  (petValues?.serviceType?.value === "Surgery" &&
                  petValues?.facility?.value
                    ? getOnlyAvailableSlots(
                        getFacilityUnAvailListById(petValues?.facility?.value),
                        getRequiredSlotList({
                          availability: vetAvailability,
                          date: petValues?.date,
                          bookedApnts: vetBookedApnts,
                          holidays,
                        })
                      )
                    : petValues?.serviceType?.value === "Grooming"
                    ? facilities?.filter((fl) => fl?.type === "BathBays")
                        ?.length === 1
                      ? getUnAvailableGroomList(
                          facilities?.filter((fl) => fl?.type === "BathBays"),
                          getRequiredSlotList({
                            availability: vetAvailability,
                            date: petValues?.date,
                            bookedApnts: vetBookedApnts,
                            holidays,
                          })
                        )
                      : getSlotsForGroomer(
                          facilities?.filter((fl) => fl?.type === "BathBays"),
                          getRequiredSlotList({
                            availability: vetAvailability,
                            date: petValues?.date,
                            bookedApnts: vetBookedApnts,
                            holidays,
                          })
                        )
                    : getRequiredSlotList({
                        availability: vetAvailability,
                        date: petValues?.date,
                        bookedApnts: vetBookedApnts,
                        holidays,
                      })
                  )?.map((item, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => {
                          petValues?.serviceType?.value === "Surgery"
                            ? handleSelectectedTimeIds(item)
                            : handleSelectTime(item);
                        }}
                        className={
                          (
                            petValues?.serviceType?.value === "Surgery"
                              ? timeObject?.ids?.find(
                                  (id) => id?.startTime === item?.startTime
                                )
                              : selectTime === item?.startTime
                          )
                            ? "bgContainerSelected cursor"
                            : "bgContainerUnselected cursor"
                        }
                      >
                        {item?.startTime}
                      </div>
                    );
                  })}
              </div>
            </div>
          )}

        {selectTimeIdError && (
          <Typography color="error" className="ml5 mt5 fs14">
            Time is Requried
          </Typography>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <CustomTextField
            name="remarks"
            fullWidth
            handleChange={(e) => onChange(e?.target?.value, "remarks")}
            value={petValues?.remarks}
            label="Remarks"
            multiline
          />
        </Grid>
        <div className="flex1-center mt20">
          <div>
            <CustomButton text="Submit" onClick={handleSubmit} smallBtn />
          </div>
        </div>
      </Grid>
    </CustomModal>
  );
};

export default BookAnAppointment;
